import { render, staticRenderFns } from "./CheckboxSelect.vue?vue&type=template&id=01088f86&"
import script from "./CheckboxSelect.vue?vue&type=script&lang=js&"
export * from "./CheckboxSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports